import { RadioChangeEvent, Typography } from 'antd'

import { RadioGroup } from '@eastcoal/formily/components/Radio'
import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'
import { FormilyProps } from '@eastcoal/formily/types/component'

const Component = ({ value, onChange, disabled }: FormilyProps) => {
  const options = [
    {
      label: (
        <>
          选择模板
          <Typography.Text type='secondary'>
            （在交易订单中将按照所选合同模板内容进行签署）
          </Typography.Text>
        </>
      ),
      value: true
    },
    {
      label: (
        <>
          自行上传
          <Typography.Text type='secondary'>
            （自拟合同并在交易订单中上传并发起签署）
          </Typography.Text>
        </>
      ),
      value: false
    }
  ]

  const onClick = (e: RadioChangeEvent) => {
    const pickerValue = e.target.value
    onChange?.(pickerValue)
  }

  return <RadioGroup options={options} value={value} onChange={onClick} />
}

export const ContractTemplateTypeRadio = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
)
